export default {"src":"/_next/static/media/icon-flag-vietnam.3bcbc5f0.svg","height":27,"width":40,"blurWidth":0,"blurHeight":0};